import type { CrmCallAnalysisRun } from '@/api/crm-call-analysis/crm-call-analysis.types'

export const callAnalysisStatusLabels: Record<
  CrmCallAnalysisRun['status'],
  string
> = {
  pending: 'Ожидает отправки',
  submitting: 'Отправляется',
  processing: 'Обрабатывается',
  completed: 'Готов',
  failed: 'Ошибка',
  expired: 'Истёк',
  dispatch_error: 'Ошибка отправки',
}

export const isCallAnalysisProcessing = (status: string) =>
  ['pending', 'submitting', 'processing', 'dispatch_error'].includes(status)
